import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSpeechBubble のスタイル
 */
export const hotlineLpSpeechBubbleStyle = tv({
    defaultVariants: {
        rounded: 'normal',
    },
    slots: {
        base: [
            'bg-[#FFFFFF]',
            'shadow-[2px_2px_8px_2px_#D6EFFF] lg:shadow-[4px_4px_16px_4px_#D6EFFF]',
            'opacity-90',
        ],
    },
    variants: {
        /** 角丸 */
        rounded: {
            normal: {
                base: ['rounded-[16px_16px_0px_16px] lg:rounded-[40px_40px_0px_40px]'],
            },
            small: {
                base: ['rounded-[12px]'],
            },
        },
    },
});
